import { useEffect, useState } from "react";
import { api } from "@/lib/api";

type Suggestions = {
  clients: string[];
  services: string[];
  hosts: string[];
};

const EMPTY: Suggestions = { clients: [], services: [], hosts: [] };

export function useSuggestions(enabled: boolean): Suggestions {
  const [data, setData] = useState<Suggestions>(EMPTY);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    (async () => {
      try {
        const [clientsRes, servicesRes, hostsRes] = await Promise.all([
          api.get<{ clients: string[] }>("/api/clients").catch(() => ({ clients: [] })),
          api.get<{ items: string[] }>("/api/services").catch(() => ({ items: [] })),
          api.get<{ items: string[] }>("/api/hosts").catch(() => ({ items: [] })),
        ]);
        if (cancelled) return;
        setData({
          clients: clientsRes.clients ?? [],
          services: servicesRes.items ?? [],
          hosts: hostsRes.items ?? [],
        });
      } catch {
        if (!cancelled) setData(EMPTY);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return data;
}
